import { createSlice } from "@reduxjs/toolkit";

export const control = createSlice({
  name: "control",
  initialState: {
    step: "BOOTING",
    aiChecking: 0,
    parts: {
      leftTiltrotor: [],
      rightTiltrotor: [],
      leftWing: [],
      rightWing: [],
      fuselage: [],
    },
    meta: {
      date: "",
      temperature: "",
      envDataX: "",
      envDataY: "",
      vertirover: "",
      vertiport: "",
      pav: "",
      sensor: "",
    },
  },
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setParts: (state, action) => {
      state.parts = {
        ...state.parts,
        [action.payload.part]: action.payload.data,
      };
    },
    setAiChecking: (state, action) => {
      state.aiChecking = action.payload;
    },
    reset: (state) => {
      state.parts = {
        leftTiltrotor: [],
        rightTiltrotor: [],
        leftWing: [],
        rightWing: [],
        fuselage: [],
      };
      state.meta = {
        date: "",
        temperature: "",
        envDataX: "",
        envDataY: "",
        vertirover: "",
        vertiport: "",
        pav: "",
        sensor: "",
      };
      state.aiChecking = 0;
    },
  },
});

export const { setStep, setParts, setAiChecking, reset } = control.actions;

export default control.reducer;
